import { Injectable } from '@angular/core';
import { LogService } from '../../_services/http/log.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  loadLogsAction,
  loadLogsErrorAction,
  loadLogsSuccessAction,
  LogsState,
  selectIsLogsInitialized,
} from './logs.store';
import { Store } from '@ngrx/store';
import {
  catchError,
  filter,
  map,
  mergeMap,
  withLatestFrom,
} from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class LogsEffect {
  constructor(
    private service: LogService,
    private action$: Actions,
    private store: Store<LogsState>
  ) {}

  load$ = createEffect(() =>
    this.action$.pipe(
      ofType(loadLogsAction),
      withLatestFrom(this.store.select(selectIsLogsInitialized)),
      filter(([action, isInitialized]) =>
        action.force === true ? true : !isInitialized
      ),
      mergeMap(() =>
        this.service.all().pipe(
          map((payload) => loadLogsSuccessAction({ payload })),
          catchError(() => of(loadLogsErrorAction()))
        )
      )
    )
  );
}
